/** @jsxImportSource theme-ui */
import React from 'react';
import { Box, Text } from '@infotrack/zenith-ui';
import { Progress } from '@/shared/components/progress/progress';
import type { ImportProgress as ImportProgressType } from '../types/import.types';

interface ImportProgressIndicatorProps {
  progress: ImportProgressType;
}

/**
 * Displays upload progress with a progress bar and percentage.
 */
export const ImportProgressIndicator: React.FC<ImportProgressIndicatorProps> = ({ progress }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'center' }}>
      <Box sx={{ textAlign: 'center' }}>
        <Box sx={{ marginBottom: 2 }}>
          <Text variant="title" as="h3">Uploading CSV File</Text>
        </Box>
        <Box sx={{ color: 'neutral/600' }}>
          <Text variant="medium">Please wait while we process your import...</Text>
        </Box>
      </Box>

      <Box sx={{ width: '100%', maxWidth: '400px' }}>
        <Progress color="#0066cc" progressValue={progress.percentage} />
        <Box sx={{ marginTop: 2, textAlign: 'center' }}>
          <Text variant="title">{progress.percentage}%</Text>
        </Box>
      </Box>

      <Box
        sx={{
          padding: 3,
          backgroundColor: 'info/10',
          borderRadius: 'medium',
          borderLeft: '4px solid',
          borderLeftColor: 'info',
          width: '100%',
        }}
      >
        <Box sx={{ color: 'neutral/700' }}>
          <Text variant="small">
            The import process validates all rows, checks for duplicates, and creates TopFive entries.
            This may take a few moments depending on file size.
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
